/**
 * 接口域名的管理
 */
const base = {
    businessBase:"/kapi/app/srm/srmwebapi",
    
}

export default base;